import { useTranslation } from 'next-i18next'

import { ExternalLink } from '~/components/ExternalLink'
import SVGImage from '~/components/Image/SVGImage'
import appConfig from '~/config/app'
import { NewsType } from '~/types/media'
import { SanityImage } from '~/types/sanity'

export default function MediaNewsItem({
  image,
  imageBgColor,
  href,
  translatedHref,
  publishedAt,
  source,
  title,
  type,
}: {
  image: SanityImage
  imageBgColor?: { hex: string }
  href: string
  translatedHref?: string
  publishedAt?: Date
  source: string
  title: string
  type: NewsType
}): React.ReactElement {
  const backgroundColor = imageBgColor?.hex ?? '#e5e5e5'
  const { t } = useTranslation('media')
  const timeString = publishedAt as unknown as string
  const { srcKey, alt } = image

  return (
    <div className="relative flex flex-col rounded shadow overflow-hidden">
      <ExternalLink className="absolute inset-0" href={href}>
        <span className="sr-only">{title}</span>
      </ExternalLink>
      <div className="h-24 lg:h-32 px-4 flex items-center justify-center" style={{ backgroundColor }}>
        <SVGImage alt={alt} imageClassName="w-full max-h-[5rem] lg:max-h-[6.5rem]" srcKey={srcKey} />
      </div>
      <div className="flex-1 p-4 space-y-5 flex flex-col justify-between">
        <h3 className="font-medium">{title}</h3>
        <div className="flex items-end justify-between text-xs font-medium">
          <time className="text-gray-medium" title={timeString}>
            {publishedAt !== undefined ? new Date(publishedAt!).toISOString().split('T')[0] : publishedAt}
          </time>
          <div className="flex flex-col items-end space-y-0.5 font-medium text-purple">
            {type === NewsType.AUDIO && source.includes('spotify.com') && (
              <SVGImage alt={t('spotifyIcon')} height={30} srcKey="media/news/logos/spotify.svg" width={30} />
            )}

            <span>{source}</span>
            {translatedHref && translatedHref.trim().length > 5 && (
              <ExternalLink
                className="relative z-10 underline font-medium text-purple"
                href={`${appConfig.assetsCdnUrl}/${translatedHref}`}
              >
                For English click here
              </ExternalLink>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
